import { render, staticRenderFns } from "./viewAktivenDetailsAddress.vue?vue&type=template&id=5062abd7&scoped=true&"
import script from "./viewAktivenDetailsAddress.vue?vue&type=script&lang=js&"
export * from "./viewAktivenDetailsAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5062abd7",
  null
  
)

export default component.exports